<template>
  <!--    <div class="auth-form&#45;&#45;wrap-col w30">-->
  <!--      <div class="input-label">Артикул изделия</div>-->
  <!--      <v-text-field-->
  <!--          type="text"-->
  <!--          outlined-->
  <!--          dense-->
  <!--          required-->
  <!--      />-->
  <!--    </div>-->
  <div class="auth-form--wrap-col w-100 mb-3">
    <div class="input-label">Наименование / Артикул</div>
    <v-autocomplete
        v-model="position.product_id"
        :items="items"
        :search-input.sync="searchModel"
        placeholder="Начните вводить наименование или артикул"
        :loading="loading"
        no-filter
        :clearable="true"
        :open-on-clear="true"
        hide-details
        hide-no-data
        class="plcolor custom-autocomplete"
        :rules="[rules.required]"
        required
        item-text="name"
        item-value="id"
        dense
        solo
        :disabled="!isEditable"
    />
  </div>


</template>

<script>
/* eslint-disable */
export default {
  name: 'Position',
  props: ['position', 'isEditable', 'action_id', 'loading'],
  data() {
    return {
      items: [],
      searchModel: '',
      rules: {
        required: value => !!value || 'Поле должно быть заполнено',
      },
    };
  },
  watch: {
    /** Вотчер для автокомплита городов */
    searchModel(val) {
      if (val && !this.items.find(el => el.name === val)) {
        this.getProducts(val);
      }
    },
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  methods: {
    getProducts(val) {
      this.$store.getters.axl
        .post('sales/api/product/get-products',
          { search: val, action_id: this.action_id, profile_id: this.user.profile_id })
        .then((result) => {
          this.items = result.data.items;
        });
    },
  },
  mounted() {
    this.position.product && this.items.push(this.position.product);
  },
};
</script>

<style scoped>

</style>